import React from "react";

const TabNavCards = ({ lang, data }) => {
  return (
    <div
      dir={lang === "AR" ? "rtl" : "ltr"}
      className="nav-cards d-flex align-items-center justify-content-center w-100 mb-5"
    >
      <section>
        <div>{data.phoneNumber}</div>
        <div>{data.code}</div>
        <div>{data.fullName}</div>
      </section>
    </div>
  );
};

export default TabNavCards;
